module.exports = __webpack_public_path__ + "static/media/gertie_logo.ceff0a9e.gif";